import React from 'react';
import { Box, Button, Dialog, Text, Flex, IconButton, TextField } from '@radix-ui/themes';
import { toast } from 'sonner';
import { observer } from 'mobx-react-lite';

import { CloseIcon } from 'shared/icons';
import { CompanySlide } from 'admin/types';

import { useSliderManager } from '../slider-manager.provider';

const SlideOrderEditDialogView = ({
   slide,
   onClose,
}: {
   slide: CompanySlide;
   onClose: () => void;
}) => {
   const sliderManager = useSliderManager();
   const [order, setOrder] = React.useState<string>(slide.display_order?.toString() || '');

   return (
      <Box className="slide-order-edit">
         <Flex justify="between" align="baseline">
            <Dialog.Title aria-describedby={undefined} color="orange">
               {slide.full_name}
            </Dialog.Title>

            <Dialog.Close>
               <IconButton size="1" color="gray">
                  <CloseIcon width={20} height={20} />
               </IconButton>
            </Dialog.Close>
         </Flex>

         <Box py="2">
            <Text color="gray" mb="2">
               Change order slide
            </Text>
            <TextField.Root
               type="number"
               color="blue"
               min={1}
               value={order}
               onChange={(e) => setOrder(e.target.value)}
            ></TextField.Root>

            <Flex justify="start" gap="3" mt="5">
               <Button
                  color="indigo"
                  size="3"
                  highContrast
                  loading={sliderManager.updateSliderState.status === 'pending'}
                  onClick={() =>
                     sliderManager.updateOrder({
                        dto: {
                           id: slide.id,
                           order: order,
                        },
                        onSuccess: () => {
                           toast.success('Slide order updated!');
                           sliderManager.loadSlider();
                           onClose();
                        },
                        onError: () => {
                           toast.error('ERROR');
                        },
                     })
                  }
               >
                  Зберегти
               </Button>

               <Dialog.Close>
                  <Button color="gray" size="3">
                     Відмінити
                  </Button>
               </Dialog.Close>
            </Flex>
         </Box>
      </Box>
   );
};

export const SlideOrderEditDialog = observer(SlideOrderEditDialogView);
